// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1kRkt","topBottomGutter":"Layout_topBottomGutter__1i5VQ"};